$(document).ready(function(){

  var currencyFormat = window.routes.moneyFormat;
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.routes.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  $('.main-product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    asNavFor: '.thumb-images-slider'
  });

  $('.thumb-images-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    asNavFor: '.main-product-images',
    focusOnSelect: true
  });
  $('.review-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  });
  $('.testionial-content-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.fbt-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        }
      }
    ]
  });

  if($(window).width() < 768){
    $(".as_easy_as_pdp .image-wrapper-blocks").slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    })
  }

  $('.wfsbm-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  });

  $('.wfsbms-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  });

  $('.video_slideshow .slideshow_slider_wrapper_new').slick({
    infinite: true,
    autoplay: false, 
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  if(window.variantStrings.pageType == 'product'){  
    // Set the date we're counting down to
    var time = $('#demo').attr('data-time');
    var countDownDate = new Date(time).getTime();
  
    // Update the count down every 1 second
    var x = setInterval(function() {
  
      // Get today's date and time
      var now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      // Display the result in the element with id="demo"
      if(days > 1){
      var daytext = 'days';
      }else{
      var daytext = 'day';
      }
      document.getElementById("demo").innerHTML = days + " "+ daytext + ' ' + hours + " hrs " + minutes + " mins " + seconds + " sec";
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("demo").parentElement.classList.add('removed');
      }else if(document.getElementById("demo").closest('.offer_timer_msg').classList.contains('removed')){
        document.getElementById("demo").closest('.offer_timer_msg').classList.remove('removed');
      }
    }, 1000);
  }

  $('body').on('mouseover','.list-menu .details', function(){
    $(this).attr('open','');
  });
  
  $('body').on('mouseout','.list-menu .details', function(){
    $(this).removeAttr('open');
  });

  $('body').on('click','.moreinfo_pop', function(){
    $('.page-container').addClass('modal-open');
    $('.more-info-popup').addClass('open');
  });
  $('body').on('click','.more-info-close',function(){
    $('.page-container').removeClass('modal-open');
    $('.more-info-popup').removeClass('open');
  });
  

  function formatMoneyWithoutTrailingZeros(cents, format = window.routes.moneyFormat) {
    // format normally (with decimals)
    let formatted = formatMoney(cents, format);

    // remove .00 only at the end
    return formatted.replace(/(\.\s?00)(?!\d)/, '');
  }

  function triggerVariantChange(variant) {
    const newUrl = new URL(window.location.href);
    if (variant) {
      if(variant.available){
        $('.product__info-wrapper [data-custom-addtocart],[data-custom-stickyaddtocart]').removeAttr('disabled').find('.button-text').text(window.variantStrings.addToCart);
      }else{
        $('.product__info-wrapper [data-custom-addtocart],[data-custom-stickyaddtocart]').attr('disabled',true).find('.button-text').text(window.variantStrings.soldOut);
      }
      newUrl.searchParams.set("variant", variant.id);

      $('#selector_wrapper_custom[name="id"]').val(variant.id).trigger('change');

      // var selectedpid = $(this).find('option:selected').attr('data-pid');
      // var jsonElement = document.getElementById('thickness_items_json');
      // var thicknessItems = JSON.parse(jsonElement.textContent || jsonElement.innerText);
      // var selectedtitle = $(this).closest('.product__info-container').find('.form [name="id"] option:selected').attr('data-title');
  
      // // Get part before `/` and trim it
      // var selectedPrefix = selectedtitle.split('/')[0].trim();
      
      // // Find a variant with the same prefix before `/`
      // var matchedVariant = thicknessItems[selectedpid].find(function(variant) {
      //   var variantPrefix = variant.title.split('/')[0].trim();
      //   return variantPrefix === selectedPrefix;
      // });
      
    
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
      var varproductData = JSON.parse(document.getElementById('productJson').textContent);
      var variantInfo = varproductData.variants[variant.id];
      if (variantInfo) {
        $('[data-variantweight]').html(variantInfo.weight);
      } else {
        console.log('Variant not found');
      }
      if(variantInfo.description != ''){
        $('[data-product-description]').html(variantInfo.description);
      }else{
        $('[data-product-description]').html(varproductData.description);
      }
        
      
      const requestUrl = newUrl.toString();
      const sectionid = $('product-info').attr('data-section');
      const infocontainer = document.querySelector('product-info');
      var hasslide = false;
      if(variant.featured_media != null){
        if($(infocontainer).find('.main-product-images .image-slide[data-mediaid="'+variant.featured_media.id+'"]').length > 0){
          var hasslide = true;  
          var gotoindex = $(infocontainer).find('.main-product-images .image-slide[data-mediaid="'+variant.featured_media.id+'"]').attr('data-slick-index');
          $(infocontainer).find('.main-product-images').slick('slickGoTo', parseInt(gotoindex));
        }
      }

      var mainpricehtml = '';
      var bottom_timer_content = '';
      var stickypricehtml =  `<div class="price">`;

      if(window.themesettings.pdpdiscountvalue != null){
        if (varproductData.product.tags.indexOf("Hide_MRP") === -1) {
          var mrpclasses = 'money strikthrough';
        }else{
          var mrpclasses = 'money';
        }
        stickypricehtml += `<div class="price--wrap product-var-price">
          <span class="${mrpclasses}">${formatMoneyWithoutTrailingZeros(variant.price)}</span>
        </div>`;
        mainpricehtml += `<div class="price--wrap product-var-price">
          <span class="price-label">M.R.P:</span>
          <span class="${mrpclasses}">${formatMoneyWithoutTrailingZeros(variant.price)}</span>
        </div>`;

        if (varproductData.product.tags.indexOf("Hide_MRP") === -1) {
          var product_price_val = variant.price - ((parseInt(window.themesettings.pdpdiscountvalue) * variant.price) / 100);
          var sp = product_price_val / (100 * 1.0);
          var result = Math.floor(sp) * 100;

          stickypricehtml += `<div class="price--wrap special--price">
            <span class="money">
              ${formatMoneyWithoutTrailingZeros(result)}
            </span>
          </div>`;

          
          mainpricehtml += `<div class="price--wrap special--price">
          <span class="price-label">Offer Price:</span>
          <span class="money">
          ${formatMoneyWithoutTrailingZeros(result)}
          </span>
          <span class="texes-text" style="font-size: 12px;">(Inc. of all taxes)</span>
          </div>`;
          
          var saveprice = Math.floor((variant.price / 100.0) - (product_price_val / 100.0)) * 100;
          bottom_timer_content += `<span class="you-save">
            <span class="price-label">You Save</span>
            <span class="saving">
              <span class="saving-result money">
                  ${formatMoneyWithoutTrailingZeros(saveprice)}
              </span>
              <span class="save-disc-val">
                (<span class="you_save_in_percentage">${window.themesettings.pdpdiscountvalue}</span>%)
              </span>
            </span>
          </span>`;

          var getSpecialPrice = product_price_val / 3650;
          bottom_timer_content += `<div class="price-per-night">
            <p class="ppn">Price Per Night: ${formatMoneyWithoutTrailingZeros(getSpecialPrice)}</p>
          </div>`;

        }

      }else{
        if (varproductData.product.tags.indexOf("Hide_MRP") === -1) {
          var mrpclasses = 'money strikthrough';
        }else{
          var mrpclasses = 'money';
        }
        if(variant.compare_at_price > variant.price){
          stickypricehtml += `<div class="price--wrap product-var-price">
          <span class="money strikthrough">${formatMoneyWithoutTrailingZeros(variant.compare_at_price)}</span></div>`;

          mainpricehtml += `<div class="price--wrap product-var-price">
            <span class="price-label">M.R.P:</span>
            <span class="money strikthrough">${formatMoneyWithoutTrailingZeros(variant.compare_at_price)}</span>
          </div>`;

          var saveprice = Math.floor(variant.compare_at_price - variant.price);
          var saveper = Math.round(((variant.compare_at_price - variant.price) * 100.0) / variant.compare_at_price);
          bottom_timer_content += `<span class="you-save">
            <span class="price-label">You Save</span>
            <span class="saving">
              <span class="saving-result money">
                  ${formatMoneyWithoutTrailingZeros(saveprice)}
              </span>
              <span class="save-disc-val">
                (<span class="you_save_in_percentage">${saveper}</span>%)
              </span>
            </span>
          </span>`;
        }

        stickypricehtml += `<div class="price--wrap special--price">
          <span class="money">
            ${formatMoney(variant.price, withoutzeroformat)}
          </span>
        </div>`;
        mainpricehtml += `<div class="price--wrap special--price">
          <span class="money">
            ${formatMoney(variant.price, withoutzeroformat)}
          </span>
          <span class="texes-text" style="font-size: 12px;">(Inc. of all taxes)</span>
        </div>`;

      }
      stickypricehtml += `</div>`;
      document.querySelector(`#sticky-price-${sectionid} .product-price`).innerHTML = stickypricehtml;
      document.querySelector(`#price-${sectionid} .mainpricing_wrapper`).innerHTML = mainpricehtml;
      document.querySelector(`#price-${sectionid} .bottom_timer_content`).innerHTML = bottom_timer_content;


    
      $.ajax({
        url: requestUrl,
        method: 'GET',
        dataType: 'html',
        success: function (responseText) {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
    
          // // Update product info section (like price)
          // const updateSourceFromDestination = (id, shouldHide = () => false) => {
          //   const source = html.getElementById(`${id}-${sectionid}`);
          //   const destination = infocontainer.querySelector(`#${id}-${sectionid}`);
          //   if (source && destination) {
          //     destination.innerHTML = source.innerHTML;
          //     destination.classList.toggle('hidden', shouldHide(source));
          //   }
          // };
    
          // updateSourceFromDestination('price');
          // updateSourceFromDestination('sticky-price');
          if(!hasslide){  
            var varmain_img = $(html).find('.main-product-images [data-variant-image]')[0];
            var varthumb_img = $(html).find('.product-images-thumbnail [data-variant-image]')[0];
            
            var mainprdimg = $('product-info').find('.main-product-images');
            var thumbimg = $('product-info').find('.product-images-thumbnail');
            mainprdimg.closest('.custom-product-images').css('opacity', '0');
            mainprdimg.slick('unslick');
            thumbimg.slick('unslick');
            console.log(mainprdimg.find('[data-variant-image]').length)
            if(mainprdimg.find('[data-variant-image]').length > 0){
              mainprdimg.find('[data-variant-image]').html($(varmain_img).html());
            }else{
              mainprdimg.prepend(varmain_img);
            }
            if(thumbimg.find('[data-variant-image]').length > 0){
              thumbimg.find('[data-variant-image]').html($(varthumb_img).html());
            }else{
              thumbimg.prepend(varthumb_img);
            }
    
            setTimeout(function() {
              mainprdimg.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                asNavFor: '.thumb-images-slider'
              });
              thumbimg.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                asNavFor: '.main-product-images',
                focusOnSelect: true
              });
              mainprdimg.closest('.custom-product-images').css('opacity', '1');
            }, 50);
          }

        },
        error: function (xhr, status, error) {
          if (status === 'abort') {
            console.log('Request aborted');
          } else {
            console.error('AJAX error:', error);
          }
        }
      });
    }else{
      $('.product__info-wrapper [data-custom-addtocart],[data-custom-stickyaddtocart]').attr('disabled',true).find('.button-text').text(window.variantStrings.unavailable);
      newUrl.searchParams.delete("variant");
    }

  }

  function getvariant(selectionvalue){
    var prddata = JSON.parse($('#productJson').html());
    var selectedvariant = prddata.product.variants.filter(function(v){
      return v.title == selectionvalue;    
    });
    return selectedvariant[0];
  }
  
  function selectvalue(selector){ 
    var values = [];
    for(var i = 0;i < 3;i++){
      if(selector.find('[data-index="'+i+'"]').length > 0){
        if(selector.find('[data-index="'+i+'"] input[type="radio"]').length > 0){
          values.push(selector.find('[data-index="'+i+'"] input[type="radio"]:checked').val());
        }else{
          if(selector.find('[data-index="'+i+'"]').closest('.categorywise_selector').length > 0){
            values.push(selector.find('.categorywise_selector.active [data-index="'+i+'"]').val());
          }else{
            values.push(selector.find('[data-index="'+i+'"]').val());
          }
        }
      }
    }
    console.log(values)
    if(values.length > 0){
      if(values.length > 1){
        return values.join(' / ');  
      }else{
        return values[0];
      }
    }else{
      return null;
    }    
  }

  $('body').on('click','.item_toggler [data-category-toggler]', function(){
    $(this).closest('.variant_picker_custom').find('[data-size="predefined"]').show();
    $(this).closest('.variant_picker_custom').find('.custom-product-tab').removeClass('active');
    $(this).closest('.variant_picker_custom').find('[data-size="custom"]').hide();
    $(this).closest('.item_main').find('[data-category-toggler]').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.variant_picker_custom').find('.categorywise_selector').removeClass('active');
    $(this).closest('.variant_picker_custom').find('.categorywise_selector[data-currentcat="'+$(this).attr('data-value')+'"]').addClass('active');
    $(this).closest('.variant_picker_custom').find('.custom_sizes_boxes input').val('');
    var selectionvalue = selectvalue($(this).closest('.variant_picker_custom'));
    var selectedvariant = getvariant(selectionvalue);
    triggerVariantChange(selectedvariant);
  });

  $('body').on('click','.item_toggler .custom-product-tab', function(){
    $(this).closest('.variant_picker_custom').find('[data-category-toggler]').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.variant_picker_custom').find('[data-size="predefined"]').hide();
    $(this).closest('.variant_picker_custom').find('[data-size="custom"]').show();
  });

  $('body').on('change','.variant_picker_custom [data-pdp-lw_selector]', function(){
    var selectionvalue = selectvalue($(this).closest('.variant_picker_custom'));
    var selectedvariant = getvariant(selectionvalue);
    triggerVariantChange(selectedvariant);
  });

  // $('body').on('change','.variant_picker_custom #pdp-height_selector', function(){
  //   var selectedpid = $(this).find('option:selected').attr('data-pid');
  //   var jsonElement = document.getElementById('thickness_items_json');
  //   var thicknessItems = JSON.parse(jsonElement.textContent || jsonElement.innerText);
  //   var selectedtitle = $(this).closest('.product__info-container').find('.form [name="id"] option:selected').attr('data-title');

  //   // Get part before `/` and trim it
  //   var selectedPrefix = selectedtitle.split('/')[0].trim();
    
  //   // Find a variant with the same prefix before `/`
  //   var matchedVariant = thicknessItems[selectedpid].find(function(variant) {
  //     var variantPrefix = variant.title.split('/')[0].trim();
  //     return variantPrefix === selectedPrefix;
  //   });
  //   var redurl = `${$(this).find('option:selected').attr('data-url')}?variant=${matchedVariant.id}`;
  //   window.location.href = redurl;
  // });

  $('body').on('change','.variant_picker_custom .unit_selector select', function(){  
    var _this = $(this);
    // $(this).closest('.dimensions_list').find('.measure_link').removeClass('active');
    // $(this).addClass('active');
    $(this).closest('.variant_picker_custom').find('.product_options_sizes').each(function(){      
      $(this).find('select').each(function(i, e){
        $(this).find('option').each(function(i, e){
          if($(e).val() != ''){
            var txtval = $(e).val().toLowerCase().replaceAll(" ", "").replaceAll('inch','').trim();
            if(txtval.indexOf('x') > -1){
              var splittext = txtval.split('x');
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(splittext[0]) / 12;
                var mainval2 = parseInt(splittext[1]) / 12;
                var feetvalue = `${mainval1.toFixed(2)} ft x ${mainval2.toFixed(2)} ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(splittext[0]);
                var mainval2 = 2.54 * parseInt(splittext[1]);
                var feetvalue = `${mainval1.toFixed(2)} cm x ${mainval2.toFixed(2)} cm`;
              }else{
                var mainval1 = parseInt(splittext[0]);
                var mainval2 = parseInt(splittext[1]);
                var feetvalue = `${mainval1} inch x ${mainval2} inch`;
              }
                              
            }else{
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(txtval) / 12;
                var feetvalue = `${mainval1.toFixed(2)} ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(txtval);
                var feetvalue = `${mainval1.toFixed(2)} cm`;
              }else{
                var mainval1 = parseInt(txtval);
                var feetvalue = `${mainval1} inch`;
              }       
            }
            $(e).text(feetvalue); 
          }          
        });
      });
    });
  });

  $('body').on('click','[data-custom-addtocart]', function(evt){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    var closest = $(this).closest('.product__info-container');
    // $('[name="properties[Custom size]"]').remove();
    if(closest.find('.custom-product-tab').hasClass('active')){
      var customvalues = [];
      var customvaluesH = [];
      closest.find('.custom_sizes_boxes .input').each(function(i,e){
        customvalues.push($(this).find('input,select').val());    
      });
      var heightval = closest.find('.variant_picker_custom').find('#pdp-height_selector').val();
      var seperate = customvalues.join(' x ').split(' x ');
      l = seperate[0];
      w = seperate[1]; 
      h = heightval.toLowerCase().trim().replace('inch','');
      if(l == '' || w == ''){
        alert('All fields are mandatory');
        // $('.form-info').removeClass('success').addClass('error').html('All fields are mandatory').fadeIn().delay(3000).fadeOut('fast');
        __this.setAttribute('aria-disabled', false);
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
        return;
        
      } else if (parseInt(l) < 15 || parseInt(w) < 15 || parseInt(l) > 84 || parseInt(w) > 84){
        alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
        // $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions in inches and not in feet/cms').fadeIn().delay(3000).fadeOut('fast');             
        __this.setAttribute('aria-disabled', false);
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
        return;
        
      } else if (l.indexOf('.') > -1 || w.indexOf('.') > -1){
        alert('Please ensure that you have added your dimensions without any decimals');
        // $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions without any decimals.').fadeIn().delay(3000).fadeOut('fast');      
        __this.setAttribute('aria-disabled', false);
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
        return;
      } else {
        if(l == '' || w == ''){
          return;
        }
        var l = parseFloat(l), w = parseFloat(w), h = parseFloat(h);
        var prddata = JSON.parse($('#productJson').html());
        var filteredSizeArr;
        console.log(prddata)

        // Step 1: Try exact match
        filteredSizeArr = prddata.product.variants.filter(function(v) {
          if (!v.available) return false;

          let sizeOpt = v.title.toLowerCase()
            .replaceAll(' ','')
            .replaceAll('inch','')
            .trim();

          let v_len = parseFloat(sizeOpt.split('x')[0].trim());
          let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
          let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());

          return v_len === l && v_width === w && v_height === h;
        });

        // Step 2: If no exact match → find smallest fitting variant
        if (filteredSizeArr.length === 0) {
          let biggerVariants = prddata.product.variants.filter(function(v) {
            if (!v.available) return false;

            let sizeOpt = v.title.toLowerCase()
              .replaceAll(' ','')
              .replaceAll('inch','')
              .trim();

            let v_len = parseFloat(sizeOpt.split('x')[0].trim());
            let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
            let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());

            return v_len >= l && v_width >= w && v_height >= h;
          });

          // Pick the smallest fitting one (minimize over-dimension)
          biggerVariants.sort((a, b) => {
            let aSize = a.title.replaceAll(' ','').replaceAll('inch','').trim().split('x');
            let bSize = b.title.replaceAll(' ','').replaceAll('inch','').trim().split('x');

            let a_len = parseFloat(aSize[0]);
            let a_width = parseFloat(aSize[1].split('/')[0]);
            let a_height = parseFloat(aSize[1].split('/')[1]);

            let b_len = parseFloat(bSize[0]);
            let b_width = parseFloat(bSize[1].split('/')[0]);
            let b_height = parseFloat(bSize[1].split('/')[1]);

            // sort by volume difference or dimension difference
            let diffA = (a_len - l) + (a_width - w) + (a_height - h);
            let diffB = (b_len - l) + (b_width - w) + (b_height - h);

            return diffA - diffB;
          });

          filteredSizeArr = biggerVariants.length ? [biggerVariants[0]] : [];
        }

        console.log("Selected Variant:", filteredSizeArr);
        if(filteredSizeArr.length == 0){
          $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
          return false;
        }
       
        const firstAvailable = filteredSizeArr.find(variant => variant.available === true);
        console.log(firstAvailable);
        closest.find('[name="id"]').val(firstAvailable.id).trigger('change');
        // $(__this).closest('[data-type="customform"]')
        //   .append(`<input type="hidden" class="removable" name="properties[Custom Size]" value="${l} inch x ${w} inch / ${h} inch">
        //   <input type="hidden" class="removable" name="properties[Length Size]" value="${l} inch">
        //   <input type="hidden" class="removable" name="properties[Breadth Size]" value="${w} inch">
        //   <input type="hidden" class="removable" name="properties[Height Size]" value="${h} inch">
        //   `);
        $(__this).closest('[data-type="customform"]')
          .append(`<input type="hidden" class="removable" name="properties[Length Size]" value="${l} inch">
          <input type="hidden" class="removable" name="properties[Breadth Size]" value="${w} inch">
          <input type="hidden" class="removable" name="properties[Height Size]" value="${h} inch">
          `);
      }
    }
    
    var form = closest.find('[data-type="customform"]').get(0);
    var drawercart = document.querySelector('cart-drawer'); 
    const formData = new FormData(form);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    console.log(drawercart);
    delete config.headers['Content-Type'];
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
        CartPerformance.measure("add:paint-updated-sections", () => {
          drawercart.renderContents(response);
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      __this.setAttribute('aria-disabled', false);
      if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      if($('[data-custom-stickyaddtocart]').length > 0){
        $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
        $('[data-custom-stickyaddtocart]').removeClass('loading');
        $('[data-custom-stickyaddtocart]').find('.loading__spinner').removeClass('hidden');  
      }
      $(__this).closest('[data-type="customform"]').find('.removable').remove();
      // Optional: measure user action
      CartPerformance.measureFromEvent("add:user-action", evt);
    });    
    
  });

  $('body').on('click', '.drawer-menu-submenu .submenu_link', function(e) {

    let $parent = $(this).closest(".drawer-menu-submenu");

    if ($parent.hasClass("active")) {
      // Close current submenu
      $parent.removeClass("active").find(".submenu_content").slideUp();
    } else {
      // Close all other submenus
      $(".drawer-menu-submenu").removeClass("active").find(".submenu_content").slideUp();

      // Open the clicked submenu
      $parent.addClass("active").find(".submenu_content").slideDown();
    }
  });

  $("body").on('click','.testionial-content-slider .view-more_button_wp a,.plp-review-item-button', function(e){
    e.preventDefault();
    $('.loox-float-toggler').trigger('click');
  });

  if($('.faq-button.showmore').length > 0){
    $("body").on("click",'.faq-button.showmore', function(){
      $(this).toggleClass("active");
      console.log($(this).closest('.faq-custom-section').find(".morecontent").length);
      $(this).closest('.faq-custom-section').find(".morecontent").slideToggle();
    
      if ($(this).hasClass("active")) {
        $(".btn-text").html("show less");
      } else {
        $(".btn-text").html("show more");
      }
    });
  }
  

  if($('#BlogTagFilter').length > 0){
    var $filterBy = $('#BlogTagFilter');

    if (!$filterBy.length) {
      return;
    }

    $filterBy.on('change', function() {
      location.href = $(this).val();
    });
  }

  $('body').on('click','[data-stickybar] [data-custom-stickyaddtocart]', function(){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    $(this).closest('product-info').find('[data-custom-addtocart]').trigger('click');
  });

  $('body').on('click','[data-type="card-customform"] .card-addtocart', function(evt){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    
    var form = $(this).closest('[data-type="card-customform"]').get(0);
    var drawercart = document.querySelector('cart-drawer'); 
    const formData = new FormData(form);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    console.log(drawercart);
    delete config.headers['Content-Type'];
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
        CartPerformance.measure("add:paint-updated-sections", () => {
          drawercart.renderContents(response);
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      __this.setAttribute('aria-disabled', false);
      if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      // Optional: measure user action
      CartPerformance.measureFromEvent("add:user-action", evt);
    });
  });

  $('body').on('click','.measuring_size a',function(e){
    e.preventDefault();
    $('.measuring_video').addClass('active').show();
  });
  $('.close-popup').click(function(){
    $(this).parent('.measuring_video').removeClass('active').hide();
  });

  $('body').on('click','.content-tabs-wrapper .tab-link', function(){
    $(this).closest('.tabs-nav').find('.tab-link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.content-tabs-wrapper').find('.tab-content,.tab-img').hide();
    $(this).closest('.content-tabs-wrapper').find('[data-tab="'+$(this).attr('data-tab')+'"]').show();
  });

  $('body').on('change','.card-product_custom .item_options_selector input,.card-product_custom .item_options_selector select', function(){
    var _this = $(this);
    console.log(_this);
    var vararry = [];
    for(var i = 0;i <= 2;i++){
      if(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').length > 0){      
        if(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').find('input[type="radio"]').length > 0){
          vararry.push(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').find('input[type="radio"]:checked').val());
        }else{
          vararry.push(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').find('select').val());  
        }
        
      }
    }
    var vartitle = vararry.join(' / ');
    var prddata = JSON.parse(_this.closest('.card-product_custom').find('.productJson').html());
    console.log(prddata)
    var selectedvariant = prddata.product.variants.filter(function(v){
      return v.title == vartitle;          
    });
    console.log(selectedvariant)
    var pricehtml = `<div class="price__container">
          <div class="price__regular">
        <span class="price-item price-item--regular">
          ${formatMoney(selectedvariant[0].price, currencyFormat)}
        </span>
      </div>
    </div>`;
    var settingdiscount = parseInt(window.themesettings.pdpdiscountvalue);
    console.log(settingdiscount);
    var product_price_val = (selectedvariant[0].price * settingdiscount) / 100;
    var special_price = selectedvariant[0].price - product_price_val;
    // if(selectedvariant[0].compare_at_price > selectedvariant[0].price){
      pricehtml += `<div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span>
              <s class="price-item price-item--regular">
                ${formatMoneyWithoutTrailingZeros(selectedvariant[0].price)}  
              </s>
            </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
          <span class="price-item price-item--sale price-item--last">
            ${formatMoneyWithoutTrailingZeros(Math.floor(special_price / 100) * 100)}
          </span>
        </div>`;
      _this.closest('.card-product_custom').find('.card-information .price').addClass('price--on-sale');
    // }else{
    //   _this.closest('.card-product_custom').find('.card-information .price').removeClass('price--on-sale');
    // }
    _this.closest('.card-product_custom').find('.card-information .price').html(pricehtml);
    _this.closest('.card-product_custom').find('[name="id"]').val(selectedvariant[0].id).trigger('change');
  });

  $('body').on('change','.cart-coupon_offer-input [name="discount_code"]', function(){
      $(this).closest('.cart-coupon_offer-input').find('#coupon_code_input').val($(this).val()).closest('.cart-coupon_offer-input').find('[data-inputapply]').removeAttr('disabled').trigger('click');
  });

  $('body').on('keyup','.cart-coupon_offer-input #coupon_code_input', function(){
    if($(this).val() != ''){
      $(this).closest('.cart-coupon_offer-input').find('[data-inputapply]').removeAttr('disabled');  
    }else{
      $(this).closest('.cart-coupon_offer-input').find('[data-inputapply]').attr('disabled','disabled');
    }
    
  });

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.cart-coupon_offer-input').find('.cart-discount__pill');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }  
    return discountCodes;
  }
  
  $('body').on('click', '.cart-coupon_offer-input [data-inputapply]', function () {
    $('.offer_input_err').remove();
    var _this = $(this);
    var sectionId = _this.closest('cart-drawer').attr('section');
    var drawercart = document.querySelector('cart-drawer');
    var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
  
    if (discountCodeValue === '') {
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    if (discountCodeValue == 'none') {
      _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val('');
    }

    _this.addClass('loading');
    _this.find('.loading__spinner').removeClass('hidden');
  
    var existingDiscountsValue = existingDiscounts();    

    if(existingDiscountsValue.length > 0 && discountCodeValue == 'none'){
      existingDiscountsValue.splice(0, 1);
      async function getupdatedata() {
        let response = await fetch(`${window.routes.cart_update_url}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            discount: existingDiscountsValue.join(','),
            sections: drawercart.getSectionsToRender().map((section) => section.section)
          })
        });
        return await response.json();
      }

      function getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }
    
      getupdatedata().then(data => {
        console.log(data);

        fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
      }).catch(error => {
        console.error('Error updating cart:', error);
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
      });

    }else{
      if (existingDiscountsValue.includes(discountCodeValue)) return;
      async function getupdatedata() {
        let response = await fetch(`${window.routes.cart_update_url}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            discount: [...existingDiscountsValue, discountCodeValue].join(','),
            sections: drawercart.getSectionsToRender().map((section) => section.section)
          })
        });
        return await response.json();
      }
    
      function getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }
    
      getupdatedata().then(data => {
        console.log(data);
        // const parsedState = JSON.parse(data);
        if (data.discount_codes.find(discount => discount.code === discountCodeValue && !discount.applicable)) {
          _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Discount code cannot be applied to your cart</p>');
          _this.removeClass('loading');
          _this.find('.loading__spinner').addClass('hidden');
          return;
        }

        fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
      }).catch(error => {
        console.error('Error updating cart:', error);
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
      });
    }
  
  });

  

  // FAQ
  $('body').on('click','.faq-custom-accordion-title', function(){
    var activeTitle = $(this);
    // Close other FAQs
    $(".faq-custom-accordion-title").not(activeTitle).removeClass("active").next(".faq-custom-accordion-body").slideUp();
    // Toggle current one
    activeTitle.toggleClass("active").next(".faq-custom-accordion-body").slideToggle();
  });

  $('body').on('click','.toggle-button', function(){
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });

  $('body').on('click','.footer-bottom-links .footer-button-wp', function(){
    $(this).closest('.footer-bottom-links').find('.links-content-main').slideToggle();
  });

  $('.custom-image-overlay-slider').slick({
    draggable: true,
    fade: false,
    arrows: true,
    infinite: false
  });

  if ($(window).width() < 769) {
    $('.better-sleep-blocks').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            arrows: false
          }
        }
      ]
    });
  }

  if ($('.plp-review-sec-list').find('.plp-review-sec-item').length > 4) {
    $('.plp-review-sec-list').slick({
      dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            dots : false,
            autoplaySpeed: 5000,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots : false,
            autoplaySpeed: 5000
          }
        }
      ]
    });
  }

  // TYPE OF MATTERSSES
  // On Click From Open
  $("body").on("click",".btn_show_form", function(){
    $(this).css("display", "none")
    $(this).next(".type-of-mat-size_and__ATC").css("display", "block");
  })

  // Get dummy Dropdown value
  $("body").on("change",".type-of-mat-size_and__ATC .option-Size", function(){
    var optionSelected = $(this).find("option:selected");
    var valueSelected  = optionSelected.val();
    var textSelected   = optionSelected.text();
    var dataTitle = $(this).attr('data-title');
    var combinedOption = dataTitle + " / " + valueSelected;
    $(`.master-selector option:contains(${combinedOption})`).prop("selected","selected");
    var variantPrice = $(".master-selector").find("option:selected").attr("variant-price");    
    $(this).closest('.type-of-mat-itm-inr').find(".type-of-mat-itm-pro-price span").html(variantPrice);
    console.log('dataTitle',dataTitle);
    console.log('optionSelected',optionSelected);
  })

  // Add to cart 
  $('body').on('click', '#type-of-mat-addToCart', function(evt) {
    const __this = this;
  
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');

    const form = $(this).closest('.type-of-mat-size_and__ATC').get(0);
    const drawercart = document.querySelector('cart-drawer');
    const optionId = $(__this).next('.master-selector').find('option:selected').val();
  
    const formData = new FormData(form);
  
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
  
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
  
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
  
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: optionId,
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
  
        CartPerformance.measure('add:paint-updated-sections', () => {
          if (drawercart) drawercart.renderContents(response);
        });
      })
      .catch((e) => {
        console.error('Add to cart failed', e);
      })
      .finally(() => {
        __this.setAttribute('aria-disabled', false);
        if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
  
        CartPerformance.measureFromEvent('add:user-action', evt);
      });
  });
  
  // Tab function
  $('.the-facts_tag-header_item-title ').click(function(e){
      e.preventDefault
    $('.the-facts_tag-header_item').removeClass('active');
    $(this).parents('.the-facts_tag-header_item').addClass('active');
    $('.the-facts_tag-content-item').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $('body').on('click','.the-facts_tag-header_item .prev-arrow', function(){
    $(this).closest('.the-facts_tag-header_item').removeClass('active');
    $(this).closest('.the-facts_tag-header_item').prev().addClass('active').find('.the-facts_tag-header_item-title').trigger('click');
  });
  $('body').on('click','.the-facts_tag-header_item .next-arrow', function(){
    $(this).closest('.the-facts_tag-header_item').removeClass('active');
    $(this).closest('.the-facts_tag-header_item').next().addClass('active').find('.the-facts_tag-header_item-title').trigger('click');
  });

  if($(".mobile-sticky-button").length > 0){
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        $(".mobile-sticky-button").addClass('active');
      } else {
        $(".mobile-sticky-button").removeClass('active');
      }
    });
  }

  $('body').on('click','.menu-drawer-container .close-icon',function(e){
    $(this).closest('.menu-drawer-container').find('[aria-controls="menu-drawer"]').trigger('click');
  });

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    var cart = event.cartData;
    console.log(cart);
    console.log('ojijijijijij');
    if(cart.items){
      var notetext = '';
      $(cart.items).each(function(i,e){
        if(e.properties['Breadth Size'] != undefined && e.properties['Height Size'] != undefined && e.properties['Length Size'] != undefined){
          notetext += `[SKU = ${e.sku} || Length - ${e.properties['Length Size']} || Breadth - ${e.properties['Breadth Size']} || Height - ${e.properties['Height Size']} ]`;
        }
      });
      fetch(`/cart/update.js`, {
        body: JSON.stringify({ note: notetext }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
    }else{
      $.getJSON('/cart.js', function(cart){
        var notetext = '';
        $(cart.items).each(function(i,e){
          if(e.properties['Breadth Size'] != undefined && e.properties['Height Size'] != undefined && e.properties['Length Size'] != undefined){
            notetext += `[SKU = ${e.sku} || Length - ${e.properties['Length Size']} || Breadth - ${e.properties['Breadth Size']} || Height - ${e.properties['Height Size']}]`;
          }
        });
        fetch(`/cart/update.js`, {
          body: JSON.stringify({ note: notetext }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        });
      });
    }
    
  });
});